export default __webpack_public_path__ + "static/media/Adf.7b2e1490.svg";